export default {
  'welcome': '欢迎',
  'home': '主页',
  'dashboard.title': '仪表盘',
  'dashboard.analysis': '分析页',
  'dashboard.monitor': '监控页',
  'dashboard.workplace': '工作台',
  'form.title': '表单页',
  'form.basic-form': '基础表单',
  'form.step-form.title': '分步表单',
  'form.step-form.info': '分步表单（填写转账信息）',
  'form.step-form.confirm': '分步表单（确认转账信息）',
  'form.step-form.result': '分步表单（完成）',
  'form.advanced-form': '高级表单',
  'list.title': '列表页',
  'list.table-list': '查询表格',
  'list.basic-list': '标准列表',
  'list.card-list': '卡片列表',
  'list.search-list.title': '搜索列表',
  'list.search-list.articles': '搜索列表（文章）',
  'list.search-list.projects': '搜索列表（项目）',
  'list.search-list.applications': '搜索列表（应用）',
  'profile.title': '详情页',
  'profile.basic': '基础详情页',
  'profile.advanced': '高级详情页',
  'result.title': '结果页',
  'result.success': '成功页',
  'result.fail': '失败页',
  'exception.title': '异常页',
  'exception.not-permission': '403',
  'exception.not-find': '404',
  'exception.server-error': '500',
  'exception.trigger': '触发错误',
  'account.title': '个人页',
  'account.center': '个人中心',
  'account.settings': '个人设置',
  'account.trigger': '触发报错',
  'account.logout': '退出登录',
  'dynamicForm': '动态表单',
  'logicflow': '组态',
  'makeChart': '图表设计器(拖拽)',
  'dragChart': '图表设计器(缩放)',
  'system':'系统',
  'setting':'设置',
  'menu':'菜单',
  'rule':'角色',
  'words':'字典',
  'logs':'日志',
  'custompage':'自定义页',
  'products':'产品',
  'product':'产品管理',
  'protype':'产品分类',
  'user':'用户管理',
  'companly':'组织架构',
  'section':'内容组件',
  'page':'页面',
  'navigate':'导航',
  'list':'订单',
  'listview':'订单管理',
  'cancellist':'退单申请',

  'devices':'设备管理',
  'device':'设备',
  'devicemoniter':'监视',
  'devicegroup':'仓库',
  'devicealarm':'报警',
  'rpclogs':'日志',
  'gateway':'网关',
  'driver':'驱动',
  'jobs':'定时任务',
  'systemconfig':'远程网关',
  'combination':'组态管理',
  'sceneconfig':'组态参数',
  'scaner':'盘煤仪',
  'camara':'热像仪',
  'combination2d':'二维组态',
  'combination3d':'三维组态',
}
